<template>
  <TopbarSpeedDial :buttons="buttons" :routeKey="routeKey"/>
</template>


<script>
/* @flow */
const TopbarSpeedDial = () =>
  import(/* webpackChunkName: "TopbarSpeedDial" */ '@/components/TopbarSpeedDial')

export default {
  name: 'NetworkProfileSpeedDial',
  props: {
    routeName: {type: String, default: ''},
    routeKey: {type: String, default: ''},
  },
  data() {
    return {
      buttonsConfig: [
        {
          label: 'Create Network Profile',
          icon: 'add',
          showForNetworkProfilesScreen: true,
          colorClass: 'accent',
          to: 'new',
        },
      ],
    }
  },
  computed: {
    buttons: function() {
      if (this.routeName.startsWith('NetworkProfiles')) {
        return this.buttonsConfig.filter(btn => btn.showForNetworkProfilesScreen)
      } else {
        return this.buttonsConfig
      }
    },
  },
  components: {
    TopbarSpeedDial,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/NetworkProfileSpeedDial.vue